import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faBan, faCircleCheck } from "@fortawesome/pro-solid-svg-icons";
import { ScheduleStatusEnum } from "./scheduleStatusEnum";
import dateTimeUtils from "utils/dateTimeUtils";

import styles from "./ScheduleStatus.module.scss";

const iconMap = {
  [ScheduleStatusEnum.Pending]: [faClock, "pending"],
  [ScheduleStatusEnum.Active]: [faCircleCheck, "active"],
  [ScheduleStatusEnum.Finished]: [faCircleCheck, "finished"],
  [ScheduleStatusEnum.Cancelled]: [faBan, "cancelled"],
} as const;

interface Props {
  status: ScheduleStatusEnum;
  startDate: string;
  endDate: string | null;
}

export const ScheduleStatus = (props: Props) => {
  const { status, startDate, endDate } = props;

  const [icon, className] = iconMap[status] || [];
  const scheduledFor = dateTimeUtils.formatDateRange(startDate, endDate);

  return (
    <div className={`${styles.root} ${styles[className]}`}>
      <FontAwesomeIcon icon={icon} className={styles.icon} size="lg" />
      <span className={styles.date}>{scheduledFor}</span>
    </div>
  );
};
